import { CollapseProps } from 'antd';
import { FC } from 'react';

import { Accordion } from '@/shared/ui/Accordion/Accordion';

import './CardAccordion.scss';

export const CardAccordion: FC<CollapseProps> = (props) => {
  return <Accordion className="custom-card-accordion" {...props} />;
};
